import router from './index';
import { ROUTER_CONST, $state } from './index';
import { redux } from '../redux';
import { TokenManager } from '../services';
import ErrorTracker from '../services/ErrorTracker';
import Redirect from '../services/Redirect';

/**
 * @returns {void}
 */
const setRedirectUrl = () => {
    Redirect.set(window.location.href);
}

const authCheck = () => { 
    const getInterval = () => TokenManager.getHalfLife() * 1000;

    const queue = (interval) => {
        setTimeout(() => {
            if (TokenManager.hasTokens()) {
                TokenManager.refreshToken();
            };

            queue(getInterval());
        }, interval);
    };

    queue(getInterval());
}

authCheck();

export const hookFns = {
    onStart: async (trans) => {
        if (TokenManager.hasTokens()) {
            const tm = TokenManager.fromLocalStorage();

            const idToken = TokenManager.decode(tm.IdToken);
            const accessToken = TokenManager.decode(tm.AccessToken);
            ErrorTracker.setUser(accessToken.username, idToken.email);

            if (trans.to().visibility === ROUTER_CONST.STATE_VISIBILITY_PUBLIC) {
                return $state.go('selectprofile');
            }
        } else {
            if (trans.to().visibility === ROUTER_CONST.STATE_VISIBILITY_PRIVATE) {
                setRedirectUrl();
                return $state.go('login');
            }
        }
    },
    onBefore: async (trans) => {
        if (!TokenManager.hasTokens() && trans.to().visibility === ROUTER_CONST.STATE_VISIBILITY_PRIVATE) {
            setRedirectUrl();
            return $state.go('login');
        }

        if (TokenManager.hasTokens() && !trans.to().skipTokenRefresh) {
            await TokenManager.refreshToken();
        }
    },
    onSuccess: (trans) => {
        window.scrollTo(0, 0);
        redux.actions.layout.set(trans.to().layout);
    },
    onError: (err) => {
        console.log('Nav Error', err);
    }
};

router.transitionService.onStart(true, hookFns.onStart);
router.transitionService.onBefore(true, hookFns.onBefore);
router.transitionService.onSuccess(true, hookFns.onSuccess);
router.transitionService.onError(true, hookFns.onError);

export default router;
